import React, { useCallback, useMemo } from "react";

import { channelsByShortName } from "../../../../../data/app__channels";
import { getPlatformUrl } from "../../../../../utils/Helpers";
import useComponentVisible from "../../../../../hooks/useComponentVisible";
import { NextIcon } from "../../Svg";

import {
  ChannelWrapper,
  ChannelMain,
  ChannelIcon,
  Loader,
  ChannelActions,
  PageLink,
  Menu,
  MenuItem,
  Wrapper
} from "../SideBarChannels.styled";

const Channel = ({
  channel,
  active,
  changePreviewChannel,
  clientView,
  campaignId,
  jobTitle,
  googleAdwordsAddition,
  fbAccountId,
  twitterCampaignId,
  loading
}) => {
  const {
    ref: channelRef,
    isComponentVisible: showMenu,
    setIsComponentVisible: setShowMenu
  } = useComponentVisible(false);

  const onClick = useCallback(() => changePreviewChannel(channel), [channel, changePreviewChannel]);

  const platformLink = useMemo(
    () =>
      getPlatformUrl({
        channel,
        campaignId,
        googleAdwordsAddition,
        campaignName: jobTitle,
        fbAccountId,
        twitterAdsCampaignId: twitterCampaignId
      }),
    [campaignId, channel, googleAdwordsAddition, jobTitle, fbAccountId, twitterCampaignId]
  );

  return (
    <ChannelWrapper ref={channelRef}>
      <ChannelMain active={active} onClick={onClick}>
        <Wrapper>
          <ChannelIcon src={`/images/icons-channels/${channel}.svg`} />
          {channelsByShortName[channel].channel_full_name}
        </Wrapper>
        {!clientView && loading ? (
          <Loader />
        ) : (
          !clientView &&
          campaignId != null && (
            <ChannelActions>
              <PageLink
                href={platformLink}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <NextIcon />
              </PageLink>
            </ChannelActions>
          )
        )}
      </ChannelMain>
      <Menu show={showMenu}>
        <MenuItem>Option 1</MenuItem>
      </Menu>
    </ChannelWrapper>
  );
};

export default Channel;
